export default __webpack_public_path__ + "img/img01.42f1112f.jpeg";